module.exports = __webpack_public_path__ + "img/gr.4d26af8a.jpg";